import { render, staticRenderFns } from "./stages-modal.vue?vue&type=template&id=79f4c2a7&scoped=true"
import script from "./stages-modal.vue?vue&type=script&lang=js"
export * from "./stages-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f4c2a7",
  null
  
)

export default component.exports